import { forwardRef } from 'react';

import { dpr } from 'Utils/dpr';
import { getAspectRatioStyles } from 'Utils/getAspectRatioStyles';

import { ISrcSetSize } from 'Components/ProductCard/ProductCardImage';
import SourceSetPictureSource from 'Components/SourceSetPictureSource';

import ExpandIcon from 'Icons/expand.svg?react';

import { ISlideModel } from './ProductGalleryContainer';
import VideoPlayerGalleryThumbnail from './VideoPlayerGalleryThumbnail';

interface IProductGalleryImageProps {
    data: ISlideModel;
    onClickHandler: () => void;
    disabled: boolean;
    srcSetSizes: ISrcSetSize;
    expandToSlider: string;
}

const ProductGalleryImage = forwardRef<
    HTMLButtonElement,
    IProductGalleryImageProps
>(
    (
        {
            data,
            onClickHandler,
            disabled,
            srcSetSizes,
            expandToSlider,
        }: IProductGalleryImageProps,
        ref
    ) => (
        <button
            ref={ref}
            style={getAspectRatioStyles(srcSetSizes)}
            type="button"
            onClick={onClickHandler}
            disabled={disabled}
            className="group/collage relative grid aspect-[var(--aspect-ratio-default)]  h-full w-full place-items-center md:aspect-[var(--aspect-ratio-md)] lg:aspect-[var(--aspect-ratio-lg)] xl:aspect-[var(--aspect-ratio-xl)] xxl:aspect-[var(--aspect-ratio-xxl)]"
        >
            <picture className="absolute left-0 top-0 h-full w-full">
                <SourceSetPictureSource
                    srcSetSizes={srcSetSizes}
                    src={data.src}
                />
                <img
                    className={`h-full w-full object-cover transition-[filter] duration-layout `}
                    src={`${data.src}?format=webp&fit=crop&height=${srcSetSizes.default.height}&width=${srcSetSizes.default.width}`}
                    srcSet={dpr(
                        `${data.src}?format=webp&fit=crop&height=${srcSetSizes.default.height}&width=${srcSetSizes.default.width}`
                    )}
                    alt={data.altText}
                    width={srcSetSizes.default.width}
                    height={srcSetSizes.default.height}
                    loading="eager"
                />
            </picture>
            {data.videoUrl && (
                <VideoPlayerGalleryThumbnail
                    altDescription={data.altText}
                    url={data.videoUrl}
                />
            )}

            {!disabled && (
                <span className="invisible absolute right-2.5 top-2.5 flex h-9 w-9 rounded-full bg-silverLight p-2.5 shadow-[1px_1px_3px_#999] transition-colors duration-layout group-hover/collage:visible group-focus/collage:visible group-focus/collage:bg-silverLight">
                    <ExpandIcon className=" text-silverLight transition duration-layout group-hover/collage:text-black group-focus/collage:text-black" />
                    <span className="sr-only">{expandToSlider}</span>
                </span>
            )}
        </button>
    )
);

export default ProductGalleryImage;
